import React, { memo, useState } from 'react';
import Colors from '../../constants/Colors';
import { View, StyleSheet } from 'react-native';
import { MaterialIcons } from '@expo/vector-icons';
import { useLocalization } from '../../store/utils/useLocalization';

import { AppText } from '../AppText';

const styles = StyleSheet.create({
  infoRow: {
    display: 'flex',
    flexDirection: 'row',
    marginBottom: 24,
  },
  header2: {
    color: Colors.primaryColor,
    fontWeight: 'bold',
    fontSize: 16,
    marginBottom: 8,
    paddingLeft: 16,
  },
  leftIconContainer: {
    width: 57,
    paddingLeft: 16,
  },
  moreLink: {
    color: Colors.primaryColor,
    textTransform: 'uppercase',
    fontFamily: 'roboto-regular',
    fontWeight: '700',
    textDecorationLine: 'underline',
    marginTop: 16,
  },
  scheduleTitle: {
    paddingLeft: 0,
    textTransform: 'capitalize',
  },
});

export type ExpandableServiceScheduleProps = {
  /** Schedule in format [0] is React.FC title, [1..n] is schedule data */
  schedule: Array<any>; //TODO: better define the schedule type
  /** Section index that shows on pantry detail page */
  index: Number;
};

const propsAreEqual = (
  prevProps: ExpandableServiceScheduleProps,
  nextProps: ExpandableServiceScheduleProps
) => prevProps.schedule.length === nextProps.schedule.length;

const ExpandableServiceSchedule = memo((props: ExpandableServiceScheduleProps): React.ReactElement => {
  const { schedule, index } = props;
  const [expanded, setExpanded] = useState(false);
  const { translation } = useLocalization();

  const labels = {
    show_more: translation.show_more,
    show_less: translation.show_less,
  };

  const toggleExpanded = () => {
    setExpanded((prevExpanded) => !prevExpanded);
  };

  return (
    <View style={styles.infoRow}>
      <View style={styles.leftIconContainer}>
        {index === 0 && <MaterialIcons name={'schedule'} size={24} color={Colors.primaryColor} />}
      </View>
      <View>
        <AppText style={[styles.header2, styles.scheduleTitle]}>{schedule[0]}</AppText>
        {expanded ? (
          <>
            {schedule.slice(1)}
            <AppText key={labels.show_less} onPress={toggleExpanded} style={styles.moreLink}>
              {labels.show_less}
            </AppText>
          </>
        ) : (
          <>
            {schedule.slice(1, 4)}
            <AppText onPress={toggleExpanded} style={styles.moreLink}>
              {labels.show_more}
            </AppText>
          </>
        )}
      </View>
    </View>
  );
}, propsAreEqual);

export default ExpandableServiceSchedule;
